<template>
    <div>
        <div
            style="margin-left: 7.3em;margin-right: 7.2em;text-align: center;"
            v-show="loading"
        >
            <app-card-loader></app-card-loader>
        </div>
        <app-sercheable-data-table
            :headers="headers"
            :search="search"
            :refresh="refresh"
            :pagination="pagination"
            :placeholder="placeholder"
            v-if="!loading"
        >
            <template slot="beforeReloadButton">
                <v-tooltip left>
                    <v-btn
                        icon
                        class="ma-0"
                        :to="{ name: 'demandReport' }"
                        slot="activator"
                    >
                        <v-icon>filter_list</v-icon>
                    </v-btn>
                    <span>{{ $t("tooltip.allFilters") }}</span>
                </v-tooltip>
            </template>
            <template slot="afterReloadButton">
                <v-btn :to="{ name: 'demandCreate' }" color="primary">{{
                    $t("label.createDemand")
                }}</v-btn>
            </template>
            <template slot="items" slot-scope="{ item }">
                    <!--Grid Demandas link de consulta pelo código-->
                    <!--<span>{{ item.system.fornecedor }}</span>-->
                    <router-link
                        :to="{ name: 'demandEdit', params: { id: item.id } }"
                        tag="tr"
                    >
                        <!-- <td class="demand-code"> -->
                        <v-tooltip bottom tag="td" class="demand-code">
                            <span slot="activator">{{ item.code }}</span>
                            <span
                                >{{ item.type.name }} -
                                {{ item.type.description }}</span
                            >
                        </v-tooltip>
                        <!-- </td> -->

                        <!-- <td class="system-acronym">{{ item.system.acronym }}</td> -->
                        <v-tooltip bottom tag="td" class="system-acronym">
                            <span slot="activator">{{ item.system.acronym }}</span>
                            <span
                                >{{ item.type.name }} -
                                {{ item.type.description }}</span
                            >
                        </v-tooltip>

                        <!-- <td class="situation-name">{{ item.status.name }}</td> -->
                        <v-tooltip bottom tag="td" class="situation-name">
                            <span slot="activator">{{ item.status.name }}</span>
                            <span
                                >{{ item.type.name }} -
                                {{ item.type.description }}</span
                            >
                        </v-tooltip>

                        <!-- <td>{{ item | demandOwner}}</td> -->
                        <v-tooltip bottom tag="td">
                            <span slot="activator">{{ item | demandOwner }}</span>
                            <span
                                >{{ item.type.name }} -
                                {{ item.type.description }}</span
                            >
                        </v-tooltip>

                        <!-- <td>{{ item.title }}</td> -->
                        <v-tooltip bottom tag="td">
                            <span slot="activator">{{ item.title }}</span>
                            <span
                                >{{ item.type.name }} -
                                {{ item.type.description }}</span
                            >
                        </v-tooltip>
                    </router-link>

            </template>
        </app-sercheable-data-table>
    </div>
</template>

<script>
import utilities from "@/helpers/utilities";
import CardLoader from '@/components/shared/CardLoader';
import SercheableDataTable from "../shared/SercheableDataTable";

export default {
    data() {
        return {
            pagination: {
                descending: true,
                sortBy: "code"
            },
            headers: [
                {
                    text: this.$t("label.code"),
                    value: "code",
                    align: "left"
                },
                {
                    text: this.$t("label.system"),
                    value: "system.acronym",
                    align: "left"
                },
                {
                    text: this.$t("label.status"),
                    value: "status.id",
                    align: "left"
                },
                {
                    text: this.$t("label.owner"),
                    value: "owner.name",
                    align: "left"
                },
                {
                    text: this.$t("label.name"),
                    value: "title",
                    align: "left"
                }
            ],
            loading: false,
            placeholder: this.$t("message.info.demandSearch")
        };
    },

    components: {
        appSercheableDataTable: SercheableDataTable,
        appCardLoader: CardLoader,
    },

    methods: {
        search(filters) {
            const demands = this.$store.getters.demandsGrid;

            return utilities.filterMultiple(
                demands,
                filters,
                (demand, regex) =>
                    regex.test(demand.code.toString()) ||
                    regex.test(demand.system.acronym) ||
                    regex.test(demand.status.name) ||
                    regex.test(demand.owner.name) ||
                    regex.test(demand.title)
            );
        },
        async refresh() {
            this.loading = true;
            await this.$store.dispatch("loadDemandsGrid");
            this.loading = false;
        }
    },
    beforeMount() {
        this.refresh();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/demands/Index.vue